module.exports = __webpack_public_path__ + "static/media/998040.9b553882.jpg";